import { useRouteError } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import './style.scss';

export default function ErrorPage() {
  const { t } = useTranslation();
  const error = useRouteError() as Error;
  console.error(error);

  return (
    <div className="ErrorPage" id="error-page">
      <h1>Oops!</h1>
      <p>{t('ErrorPage.p.text')}.</p>
      <pre>
        {error.message || JSON.stringify(error)}
      </pre>
    </div>
  );
};
